export default "All you know is that you know nothing ...";